import { ResponseGetStoresList } from "@CommonApi/stores/list";
import { omniAtom } from "src/utils/atoms";

export const storesPageAtom = omniAtom({
  key: "pages/stores",
  value: undefined as undefined | null | ResponseGetStoresList,
});
